
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacto/ventas",
      function () {
        return require("private-next-pages/contacto/ventas/index.js");
      }
    ]);
  